import React, { useState , useEffect } from "react";
import axios from "axios";

const TableFourB = props => {
  const API = props.API;
  const [CAY, setCAY] = useState([0]);
  const [CAYm1, setCAYm1] = useState([0, 0]);
  const [CAYm2, setCAYm2] = useState([0, 0, 0]);
  const [CAYm3, setCAYm3] = useState([0, 0, 0, 0]);
  const [CAYm4LYG, setCAYm4LYG] = useState([0, 0, 0, 0, 0]);
  const [CAYm5LYGm1, setCAYm5LYGm1] = useState([0, 0, 0, 0, 0]);
  const [CAYm6LYGm2, setCAYm6LYGm2] = useState([0, 0, 0, 0, 0]);
  const [editable, setEditable] = useState(false);

  const submitForm = data => {
    var settings = {
      url: API + "/sectionfourb-create",
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      data: {
        cay: data.cay,
        caym1: data.caym1,
        caym2: data.caym2,
        caym3: data.caym3,
        caym4lyg: data.caym4lyg,
        caym5lygm1: data.caym5lygm1,
        caym6lygm2: data.caym6lygm2,


      }
    };

    axios(settings)
      .then(res => {
        console.log("Database Stored");
        console.log(res.data);
      })
      .catch(err => {
        console.log(err);
      });
  };

  useEffect(() => {
    var settings = {
      url: API + "/sectionfourb-get",
      method: "GET",
      headers: {
        "Content-Type": "application/json"
      }
    };

    axios(settings)
      .then(res => {
        let cay = res.data.cay;
        let caym1 = res.data.caym2;
        let caym2 = res.data.caym3;
        let caym3 = res.data.caym3;
        let caym4lyg = res.data.caym4lyg;
        let caym5lygm1 = res.data.caym5lygm1;
        let caym6lygm2 = res.data.caym6lygm2;
        
        cay.length === 0 ? setCAY([0, 0, 0]) : setCAY(cay);
        caym1.length === 0 ? setCAYm1([0, 0, 0]) : setCAYm1(caym1);
        caym2.length === 0 ? setCAYm2([0, 0, 0]) : setCAYm2(caym2);
        caym3.length === 0 ? setCAYm3([0, 0, 0]) : setCAYm3(caym3);
        caym4lyg.length === 0 ? setCAYm4LYG([0, 0, 0]) : setCAYm4LYG(caym4lyg);
        caym5lygm1.length === 0 ? setCAYm5LYGm1([0, 0, 0]) : setCAYm5LYGm1(caym5lygm1);
        caym6lygm2.length === 0 ? setCAYm6LYGm2([0, 0, 0]) : setCAYm6LYGm2(caym6lygm2);
      })
      .catch(err => {
        console.log(err);
      });
  }, []);


  const changeData = (type, val, index, previousData) => {
    val = Number(val);

    switch (type) {
      case "CAY":
        if (index === 0) setCAY([val]);
        break;
      case "CAYm1":
        if (index === 0) setCAYm1([val, previousData[1]]);
        if (index === 1) setCAYm1([previousData[0], val]);
        break;
      case "CAYm2":
        if (index === 0) setCAYm2([val, previousData[1], previousData[2]]);
        if (index === 1) setCAYm2([previousData[0], val, previousData[2]]);
        if (index === 2) setCAYm2([previousData[0], previousData[1], val]);
        break;
      case "CAYm3":
        if (index === 0)
          setCAYm3([val, previousData[1], previousData[2], previousData[3]]);
        if (index === 1)
          setCAYm3([previousData[0], val, previousData[2], previousData[3]]);
        if (index === 2)
          setCAYm3([previousData[0], previousData[1], val, previousData[3]]);
        if (index === 3)
          setCAYm3([previousData[0], previousData[1], previousData[2], val]);
        break;
      case "CAYm4LYG":
        if (index === 0)
          setCAYm4LYG([
            val,
            previousData[1],
            previousData[2],
            previousData[3],
            previousData[4]
          ]);
        if (index === 1)
          setCAYm4LYG([
            previousData[0],
            val,
            previousData[2],
            previousData[3],
            previousData[4]
          ]);
        if (index === 2)
          setCAYm4LYG([
            previousData[0],
            previousData[1],
            val,
            previousData[3],
            previousData[4]
          ]);
        if (index === 3)
          setCAYm4LYG([
            previousData[0],
            previousData[1],
            previousData[2],
            val,
            previousData[4]
          ]);
        if (index === 4)
          setCAYm4LYG([
            previousData[0],
            previousData[1],
            previousData[2],
            previousData[3],
            val
          ]);
        break;
      case "CAYm5LYGm1":
        if (index === 0)
          setCAYm5LYGm1([
            val,
            previousData[1],
            previousData[2],
            previousData[3],
            previousData[4]
          ]);
        if (index === 1)
          setCAYm5LYGm1([
            previousData[0],
            val,
            previousData[2],
            previousData[3],
            previousData[4]
          ]);
        if (index === 2)
          setCAYm5LYGm1([
            previousData[0],
            previousData[1],
            val,
            previousData[3],
            previousData[4]
          ]);
        if (index === 3)
          setCAYm5LYGm1([
            previousData[0],
            previousData[1],
            previousData[2],
            val,
            previousData[4]
          ]);
        if (index === 4)
          setCAYm5LYGm1([
            previousData[0],
            previousData[1],
            previousData[2],
            previousData[3],
            val
          ]);
        break;
      case "CAYm6LYGm2":
        if (index === 0)
          setCAYm6LYGm2([
            val,
            previousData[1],
            previousData[2],
            previousData[3],
            previousData[4]
          ]);
        if (index === 1)
          setCAYm6LYGm2([
            previousData[0],
            val,
            previousData[2],
            previousData[3],
            previousData[4]
          ]);
        if (index === 2)
          setCAYm6LYGm2([
            previousData[0],
            previousData[1],
            val,
            previousData[3],
            previousData[4]
          ]);
        if (index === 3)
          setCAYm6LYGm2([
            previousData[0],
            previousData[1],
            previousData[2],
            val,
            previousData[4]
          ]);
        if (index === 4)
          setCAYm6LYGm2([
            previousData[0],
            previousData[1],
            previousData[2],
            previousData[3],
            val
          ]);
        break;
      default:
        console.log("Default");
    }
  };

  return (
    <div>
      <h2>Table 4B</h2>
      <table border="1" cellPadding="10" width="80%">
        <tbody>
          {/* Heading */}
          <tr>
            <th>
              Year of entry <br />
            </th>
            <th>
              N1 + N2 + N3 <br />
              (As defined above)
            </th>
            <th>
              w/o fail <br />1 Year
            </th>
            <th>
              w/o fail <br />2 Year
            </th>
            <th>
              w/o fail <br />3 Year
            </th>
            <th>
              w/o fail <br />4 Year
            </th>
          </tr>

          {/* CAY */}
          <tr>
            <td>
              CAY <br /> (2017-2018)
            </td>
            {CAY.map((d, index) => {
              if (editable)
                return (
                  <td key={index}>
                    <input
                      type="number"
                      value={d}
                      onChange={e =>
                        changeData("CAY", e.target.value, index, [CAY[0]])
                      }
                    />
                  </td>
                );
              else return <td key={index}>{d}</td>;
            })}
            <td style={{ backgroundColor: "#d3d3d3" }}></td>
            <td style={{ backgroundColor: "#d3d3d3" }}></td>
            <td style={{ backgroundColor: "#d3d3d3" }}></td>
            <td style={{ backgroundColor: "#d3d3d3" }}></td>
          </tr>

          {/* CAYm1 */}
          <tr>
            <td>
              CAYm1 <br />
              (2016-2017)
            </td>
            {CAYm1.map((d, index) => {
              if (editable)
                return (
                  <td key={index}>
                    <input
                      type="number"
                      value={d}
                      onChange={e =>
                        changeData("CAYm1", e.target.value, index, [
                          CAYm1[0],
                          CAYm1[1]
                        ])
                      }
                    />
                  </td>
                );
              else return <td key={index}>{d}</td>;
            })}
            <td style={{ backgroundColor: "#d3d3d3" }}></td>
            <td style={{ backgroundColor: "#d3d3d3" }}></td>
            <td style={{ backgroundColor: "#d3d3d3" }}></td>
          </tr>

          {/* CAYm2 */}
          <tr>
            <td>
              CAYm2
              <br />
              (2015-2016)
            </td>
            {CAYm2.map((d, index) => {
              if (editable)
                return (
                  <td key={index}>
                    <input
                      type="number"
                      value={d}
                      onChange={e =>
                        changeData("CAYm2", e.target.value, index, [
                          CAYm2[0],
                          CAYm2[1],
                          CAYm2[2]
                        ])
                      }
                    />
                  </td>
                );
              else return <td key={index}>{d}</td>;
            })}
            <td style={{ backgroundColor: "#d3d3d3" }}></td>
            <td style={{ backgroundColor: "#d3d3d3" }}></td>
          </tr>

          {/* CAYm3 */}
          <tr>
            <td>
              CAYm3 <br />
              (2014-2015)
            </td>
            {CAYm3.map((d, index) => {
              if (editable)
                return (
                  <td key={index}>
                    <input
                      type="number"
                      value={d}
                      onChange={e =>
                        changeData("CAYm3", e.target.value, index, [
                          CAYm3[0],
                          CAYm3[1],
                          CAYm3[2],
                          CAYm3[3]
                        ])
                      }
                    />
                  </td>
                );
              else return <td key={index}>{d}</td>;
            })}
            <td style={{ backgroundColor: "#d3d3d3" }}></td>
          </tr>

          {/* CAYm4LYG */}
          <tr>
            <td>
              CAYm4LYG <br />
              (2013-2014)
            </td>
            {CAYm4LYG.map((d, index) => {
              if (editable)
                return (
                  <td key={index}>
                    <input
                      type="number"
                      value={d}
                      onChange={e =>
                        changeData("CAYm4LYG", e.target.value, index, [
                          CAYm4LYG[0],
                          CAYm4LYG[1],
                          CAYm4LYG[2],
                          CAYm4LYG[3],
                          CAYm4LYG[4]
                        ])
                      }
                    />
                  </td>
                );
              else return <td key={index}>{d}</td>;
            })}
          </tr>

          {/* CAYm5LYGm1 */}
          <tr>
            <td>
              CAYm5LYGm1 <br />
              (2012-2013)
            </td>
            {CAYm5LYGm1.map((d, index) => {
              if (editable)
                return (
                  <td key={index}>
                    <input
                      type="number"
                      value={d}
                      onChange={e =>
                        changeData("CAYm5LYGm1", e.target.value, index, [
                          CAYm5LYGm1[0],
                          CAYm5LYGm1[1],
                          CAYm5LYGm1[2],
                          CAYm5LYGm1[3],
                          CAYm5LYGm1[4]
                        ])
                      }
                    />
                  </td>
                );
              else return <td key={index}>{d}</td>;
            })}
          </tr>

          {/* CAYm6LYGm2 */}
          <tr>
            <td>
              CAYm6LYGm2 <br />
              (2011-2012)
            </td>
            {CAYm6LYGm2.map((d, index) => {
              if (editable)
                return (
                  <td key={index}>
                    <input
                      type="number"
                      value={d}
                      onChange={e =>
                        changeData("CAYm6LYGm2", e.target.value, index, [
                          CAYm6LYGm2[0],
                          CAYm6LYGm2[1],
                          CAYm6LYGm2[2],
                          CAYm6LYGm2[3],
                          CAYm6LYGm2[4]
                        ])
                      }
                    />
                  </td>
                );
              else return <td key={index}>{d}</td>;
            })}
          </tr>
        </tbody>
      </table>
      <p>
        <b>w/o Fail - Year </b> Number of students who have successfully
        graduated without backlogs in any semester/year of study (Without
        Backlog means no compartment or failures in any semester/year of study)
      </p>
      {editable ? null : (
        <button onClick={() => setEditable(true)}>Edit</button>
      )}
      &nbsp;
      <button
        onClick={() => {
          setEditable(false);
          var data = {
            cay : CAY,
            caym1 : CAYm1,
            caym2 : CAYm2,
            caym3 : CAYm3,
            caym4lyg : CAYm4LYG,
            caym5lygm1 : CAYm5LYGm1,
            caym6lygm2 : CAYm6LYGm2
          };
          console.log(data);
        }}
      >
        Submit
      </button>
    </div>
  );
};

export default TableFourB;
